/**
 * Typen und Masse der 3D-Figur ohne three.js. Der Haupt-Chunk (Insel,
 * Platzierung) darf nur von hier importieren — jeder Import aus
 * `mat3d-figure.ts` oder seinen Modulen zoege three.js in den Haupt-Chunk, und
 * das Budget-Skript bricht den Build ab.
 */

/** Hoehe von `classic` inkl. Antenne in 3D-Einheiten. */
export const CLASSIC_HEIGHT = 2.08;

/** SVG-viewBox-Einheiten je 3D-Einheit (`lab/designs/classic.js`). */
export const CLASSIC_SVG_UNITS_PER_UNIT = 67.5;

/** Boden der Figur in der SVG-viewBox (y). */
export const CLASSIC_SVG_GROUND_Y = 152;

/** Gruende, aus denen die laufende Figur auf die SVG zurueckfaellt. */
export type FigureFailure = "context_lost" | "shader" | "watchdog" | "slow_frames";

/** Wo die Figur auf der Leinwand steht (CSS-Pixel). */
export type FigureFrame = {
    /** Hoehe der Figur inkl. Antenne. */
    figurePx: number;
    /** Abstand der Fuesse von der Oberkante der Leinwand. */
    feetPx: number;
};

export type MatFigureOptions = {
    canvas: HTMLCanvasElement;
    gl: WebGL2RenderingContext;
    frame: FigureFrame;
    /** Blick folgt dem Zeiger (nur auf Geraeten mit Hover). */
    follow: boolean;
    /** Erster gesunder Frame — auch nach einem wiederhergestellten Grafikkontext. */
    onReady: () => void;
    onFail: (reason: FigureFailure, healCount: number) => void;
};

export type MatFigureHandle = {
    /** Rendern fortsetzen (sichtbar im Viewport, Tab sichtbar). */
    resume: () => void;
    /** Rendern anhalten. */
    pause: () => void;
    /** Neuer Rahmen nach einer Groessenaenderung der Leinwand. */
    resize: (frame: FigureFrame) => void;
    /** Freudensprung (Klick). */
    jump: () => void;
    /** Aufmerksamkeit (Zeiger kommt auf die Figur). */
    attention: () => void;
    /** Zeigerposition in Client-Koordinaten fuer den Blick. */
    pointer: (clientX: number, clientY: number) => void;
    dispose: () => void;
};

/** Der dynamisch importierte Chunk. */
export type Mat3dFigureModule = {
    /**
     * Baut die Figur in mehreren Aufgaben auf (Renderer, Szene, Rig, Shader)
     * und gibt dazwischen den Hauptthread frei. Gerendert wird erst nach
     * `resume()`. Verwirft bei einem Fehler im Aufbau.
     */
    startMatFigure: (options: MatFigureOptions) => Promise<MatFigureHandle>;
};
